import { Glyph } from '../../common/Glyph';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './MainNavProfileMenuItemContent.module.css';

interface MainNavProfileMenuItemContentProps {
  glyphSource: string;
  label: string;
  isPressed: boolean;
  isOpen: boolean;
  mirrorRTL?: boolean;
  hasSubmenu?: boolean;
}

/** Profile menu content that owns its icon colors for hover, press, and an open submenu. */
export function MainNavProfileMenuItemContent(props: MainNavProfileMenuItemContentProps) {
  return (
    <span className={styles.root} data-is-pressed={props.isPressed} data-is-open={props.isOpen}>
      <Glyph
        source={props.glyphSource}
        color={'var(--module-glyph-color)'}
        mirrorRTL={props.mirrorRTL}
      />
      <span className={styles.label}>{props.label}</span>

      {props.hasSubmenu === true && (
        <Glyph
          source={glyph.core.chevronRightBold}
          color={'var(--module-glyph-color)'}
          size={theme.icon.size_small}
          mirrorRTL={true}
        />
      )}
    </span>
  );
}
